import { useMemo } from 'react';
import { DocumentStage } from '@sib/api';
import { createUseAppTranslation } from '@sib/i18n';

const useDocumentsTranslation = createUseAppTranslation('documents');

export const useDocumentStageOptions = () => {
  const { t } = useDocumentsTranslation();

  return useMemo(
    () => [
      {
        label: t('enums.documentStage.uploaded'),
        value: DocumentStage.Uploaded,
      },
      {
        label: t('enums.documentStage.inProgress'),
        value: DocumentStage.InProgress,
      },
      {
        label: t('enums.documentStage.actionNeeded'),
        value: DocumentStage.ActionNeeded,
      },
      {
        label: t('enums.documentStage.approved'),
        value: DocumentStage.Approved,
      },
      {
        label: t('enums.documentStage.rejected'),
        value: DocumentStage.Rejected,
      },
      {
        label: t('enums.documentStage.expired'),
        value: DocumentStage.Expired,
      },
    ],
    [t]
  );
};
